<template>
  <div></div>
</template>

<script>
export default {
  mounted() {
    this.$store.dispatch("clearCredentials");
    this.$router.replace('/login');
  }
}
</script>

